// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  connectFirestoreEmulator,
  getFirestore,
  initializeFirestore,
} from "firebase/firestore";
import {
  connectFirestoreEmulator as connectFirestoreLiteEmulator,
  getFirestore as getFirestoreLite,
  initializeFirestore as initializeFirestoreLite,
} from "firebase/firestore/lite";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import {
  FIREBASE_AUTH_EMULATOR_PORT,
  FIREBASE_EMULATOR_HOST,
  FIREBASE_FIRESTORE_EMULATOR_PORT,
  FIREBASE_FUNCTIONS_EMULATOR_PORT,
  firebaseClientConfig,
  getMissingFirebaseConfigKeys,
  shouldForceFirestoreLongPolling,
  shouldLogFirestoreDebugTiming,
  shouldUseFirebaseEmulators,
} from "./appEnvironment";

// https://firebase.google.com/docs/web/setup#available-libraries

const missingFirebaseConfigKeys = getMissingFirebaseConfigKeys();

if (missingFirebaseConfigKeys.length > 0) {
  throw new Error(
    `Missing Firebase client environment values: ${missingFirebaseConfigKeys.join(
      ", "
    )}`
  );
}

// Initialize Firebase and return database
const firebaseApp = initializeApp(firebaseClientConfig);
const useFirebaseEmulators = shouldUseFirebaseEmulators();
const forceFirestoreLongPolling = shouldForceFirestoreLongPolling();
const logFirestoreDebugTiming = shouldLogFirestoreDebugTiming();
const db =
  forceFirestoreLongPolling
    ? initializeFirestore(firebaseApp, {
        // Enable this only when we need the older XHR long-polling transport
        // to work around a local emulator/browser issue.
        experimentalForceLongPolling: true,
        experimentalLongPollingOptions: {
          timeoutSeconds: 25,
        },
        useFetchStreams: false,
      })
    : getFirestore(firebaseApp);
const dbLite =
  forceFirestoreLongPolling
    ? initializeFirestoreLite(firebaseApp, {})
    : getFirestoreLite(firebaseApp);
const auth = getAuth(firebaseApp);
const functions = getFunctions(firebaseApp);

// If running on a local loopback host use the emulators.
// LAN or production hosts continue to use the live Firebase project.
if (useFirebaseEmulators) {
  connectFirestoreEmulator(
    db,
    FIREBASE_EMULATOR_HOST,
    FIREBASE_FIRESTORE_EMULATOR_PORT
  );
  connectFirestoreLiteEmulator(
    dbLite,
    FIREBASE_EMULATOR_HOST,
    FIREBASE_FIRESTORE_EMULATOR_PORT
  );
  connectAuthEmulator(
    auth,
    `http://${FIREBASE_EMULATOR_HOST}:${FIREBASE_AUTH_EMULATOR_PORT}`
  );
  connectFunctionsEmulator(
    functions,
    FIREBASE_EMULATOR_HOST,
    FIREBASE_FUNCTIONS_EMULATOR_PORT
  );
}

if (logFirestoreDebugTiming) {
  console.info("[firebase] transport", {
    authEmulatorPort: useFirebaseEmulators ? FIREBASE_AUTH_EMULATOR_PORT : null,
    firestoreEmulatorPort: useFirebaseEmulators
      ? FIREBASE_FIRESTORE_EMULATOR_PORT
      : null,
    forceFirestoreLongPolling,
    functionsEmulatorPort: useFirebaseEmulators
      ? FIREBASE_FUNCTIONS_EMULATOR_PORT
      : null,
    hostname:
      typeof location === "undefined" ? "unknown" : location.hostname,
    useFirebaseEmulators,
  });
}

export {
  auth,
  db,
  dbLite,
  functions,
  firebaseApp,
  firebaseClientConfig as firebaseConfig,
};
//export default db;
